import { configureStore } from '@reduxjs/toolkit';

import auditableElementsReducer from '@/slices/auditableElementsSlice';
import authReducer from '@/slices/authSlice';
import installedProductsReducer from '@/slices/installedProductsSlice';
import userProfileReducer from '@/slices/userProfileSlice';
import {
  loadState,
  saveState
} from '@/solaris-lens-common-lib-web/src/utils/localStorage';
import { AuthState } from '@/types';

const persistedState = loadState('reduxState');

type InitialRootState = {
  auth: AuthState;
};

export const store = configureStore({
  reducer: {
    auth: authReducer,
    userProfile: userProfileReducer,
    auditableElements: auditableElementsReducer,
    installedProducts: installedProductsReducer
  },
  preloadedState: persistedState as InitialRootState
});

store.subscribe(() => {
  saveState(store.getState(), 'reduxState');
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
